module.exports = __webpack_public_path__ + "static/img/image-benefit.d77e135.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/after-bootcamp/pengu/image-benefit/image-benefit.png
// module id = tBgC
// module chunks = 35